<template lang="html">

  <section class="not-found">
    <h1>not-found Component</h1>
  </section>

</template>

<script lang="js">
  export default  {
    name: 'not-found',
    props: [],
    mounted() {

    },
    data() {
      return {

      }
    },
    methods: {

    },
    computed: {

    }
}
</script>

<style scoped lang="scss">
  .not-found {

  }
</style>



// WEBPACK FOOTER //
// src/components/NotFound.vue